import React, { InputHTMLAttributes } from "react";
import { StyledCheckbox } from "./Checkbox.styled";
import { ReactComponent as CheckMarkIcon } from "../../../icons/check.svg";
import { ReactComponent as IndeterminateMarkIcon } from "../../../icons/minus.svg";
import { IconManager } from "../IconManager/IconManager";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import { theme } from "../../../constants/StyledComponents";
import { BodyTyp } from "../../Typography/Typography";

interface CheckboxProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> {
  label?: string;
  onChange?: (value: boolean) => void;
  value: boolean;
  indeterminate?: boolean;
}

export const Checkbox = ({
  label,
  onChange,
  value,
  indeterminate,
  ...props
}: CheckboxProps) => {
  return (
    <StyledCheckbox>
      <div className={"checkbox"}>
        <input
          className={`checkbox-default${
            indeterminate
              ? " checkbox-indeterminate"
              : value
                ? " checkbox-checked"
                : ""
          }`}
          type="checkbox"
          onChange={(e) => {
            if (onChange && !props.disabled) {
              onChange(e.target.checked);
            }
          }}
          checked={value}
          {...props}
        />
        {indeterminate ? (
          <div className="indeterminate-mark">
            <IconManager size={IconSizeEnum.XSMALL} color={theme.colors.white}>
              <IndeterminateMarkIcon />
            </IconManager>
          </div>
        ) : (
          <div className="checkmark">
            <IconManager size={IconSizeEnum.XSMALL} color={theme.colors.white}>
              <CheckMarkIcon />
            </IconManager>
          </div>
        )}
      </div>
      {label && (
        <BodyTyp variant="2" fontWeight={FontWeightEnum.MEDIUM}>
          {label}
        </BodyTyp>
      )}
    </StyledCheckbox>
  );
};
